export const productName = 'MEGAPACK SEGURIDAD E HIGIENE LISTO™';
export const productImage = 'https://cdn.magicpatterns.com/uploads/hXP56m53zohGZX9z2csXPA/ChatGPT_Image_2_sept_2026,_13_32_54.png';

export const checkoutUrl = 'https://megapack-seguridad-e-higiene-listo.impultienda.ar/checkout';

export const price = '$19.990 ARS';
export const priceBefore = '$119.000 ARS';

export const totalVolumes = 9;
export const totalBonuses = 5;
export const bonusTotalValue = '$70.000 ARS';

export const baseItems = [
  'TOMO 1: Fundamentos de Seguridad e Higiene Laboral',
  'TOMO 2: Identificación de Peligros y Evaluación de Riesgos',
  'TOMO 3: Riesgos Físicos, Químicos y Biológicos',
  'TOMO 4: Seguridad en Máquinas, Herramientas y Riesgo Eléctrico',
  'TOMO 5: Incendios, Emergencias, Evacuación y Primera Respuesta',
  'TOMO 6: Ergonomía, EPP, Señalización y Gestión Preventiva',
  'TOMO 7: Planificación Docente y Secuencias Didácticas',
  'TOMO 8: 100 Casos Prácticos y Desafíos de Seguridad e Higiene',
  'TOMO 9: Proyectos Integradores y Simulaciones Profesionales',
  'BONO 1: Kit de 50 Checklists y Formularios de Seguridad e Higiene',
  'BONO 2: Kit de Evaluaciones, Rúbricas y Exámenes de Seguridad e Higiene',
  'BONO 3: Banco de 150 Actividades Prácticas de Seguridad e Higiene',
  'BONO 4: Planificación Anual 2026 + Cronograma Docente',
  'BONO 5: Mega Kit Visual de Seguridad e Higiene — 100 Láminas e Infografías',
  'Acceso de por vida y actualizaciones gratuitas',
];

export const checklist: Array<[string, string]> = [
  ['Contenido 100% argentino', 'Normativas vigentes, contexto laboral real, políticas de prevención en Argentina y casos de empresas y espacios técnicos argentinos.'],
  ['Material imprimible', 'Listo para usar en el aula, taller o laboratorio, o entregar directamente al alumno.'],
  ['Formularios y plantillas reales', 'Checklists, planes de evacuación, matrices de riesgo, inspecciones y proyectos adaptados a 2026.'],
  ['Casos prácticos resueltos paso a paso', 'Con datos reales del campo de la seguridad e higiene laboral en Argentina.'],
  ['Vocabulario técnico explicado', 'Sin jerga innecesaria, accesible para todos los niveles educativos.'],
  ['Conexión con la actualidad', 'Nuevos riesgos, nuevas normativas, nuevas máquinas, nuevas sustancias, nuevas realidades laborales.'],
  ['Normativa argentina actualizada', 'Ley 19.587, resoluciones vigentes, normas IRAM y estándares internacionales aplicados a Argentina.'],
  ['Garantía de 7 días', 'Sin preguntas ni formularios.'],
  ['Acceso inmediato', 'Descarga directa tras la compra.'],
  ['Actualizaciones gratuitas', 'Acceso de por vida al material.'],
];
